import StudentSelector from './student-selector.vue';

export default {
  install(application) {
    application.component('yx-student-selector', StudentSelector);
  },
};
